import { Routes } from '@angular/router';

import { backButtonResolver } from '@common/back-button/back-button.resolver';
import { moduleResolver } from '@common/module-resolver.resolver';
import { translationResolver } from '@common/translation-resolver.resolver';
import { authGuard } from '@guards/auth.guard';
import { errorGuard } from '@guards/error.guard';
import { testGuard } from '@guards/test.guard';

export let routes: Routes = [];

const clientUrl = window.location.pathname.split('/')[1] || '';

if (clientUrl.length) {
    routes = [
        {
            path: `${clientUrl}`,
            children: [
                {
                    path: 'landpage',
                    loadComponent: () => import('@app/landpage/landpage.component').then(c => c.LandpageComponent),
                    title: 'Agile Hub - Select module',
                    data: { moduleName: 'LANDPAGE' },
                    resolve: { module: moduleResolver, backButton: backButtonResolver },
                },
                {
                   path: 'testdev',
                   loadComponent: () => import('@app/testdev/testdev.component').then(c => c.TestdevComponent),
                   title: 'Test development',
                   canActivate: [testGuard]
                },
                //{
                //    path: 'sas-grid-demo',
                //    loadComponent: () => import('@app/testdev/sas-grid-demo/sas-grid-demo.component').then(c => c.SasGridDemoComponent),
                //    title: 'SAS Grid Demo'
                //},
                {
                    path: 'my-account',
                    loadComponent: () => import('@app/my-account/my-account.component').then(c => c.MyAccountComponent),
                    title: 'My account',
                    data: { moduleName: 'MY_ACCOUNT_VIEW' },
                    resolve: { translation: translationResolver },
                    canActivate: [authGuard]
                },
                {
                    path: 'accessibility',
                    loadComponent: () => import('@app/accessibility/accessibility.component').then(c => c.AccessibilityComponent),
                    title: 'Accessibility',
                    resolve: { module: moduleResolver }
                },
                {
                    path: 'cookies',
                    loadComponent: () => import('@app/cookies/cookies.component').then(c => c.CookiesComponent),
                    title: 'Cookies',
                    resolve: { module: moduleResolver }
                },
                {
                    path: 'error',
                    loadComponent: () => import('@app/error/error.component').then(c => c.ErrorComponent),
                    title: 'Error',
                    canActivate: [errorGuard]
                },
                { path: '', redirectTo: `landpage`, pathMatch: 'prefix' },
            ]
        },
        {
            path: `${clientUrl}`,
            loadChildren: () => import('@identity/identity.routes').then(r => r.IdentityRoutes),
        },
        {
            path: `${clientUrl}`,
            loadChildren: () => import('@modules/modules.routes').then(r => r.ModulesRoutes),
        },
        {
            path: `${clientUrl}`,
            loadChildren: () => import('@administration/administration.routes').then(r => r.AdministrationRoutes),
        },
        { path: '**', redirectTo: `${clientUrl}/landpage`, pathMatch: 'full' }
    ];
}
else {
    routes = [{ path: '**', redirectTo: 'error', pathMatch: 'full' }];
    console.error('Client not found');
}
